import { render, staticRenderFns } from "./ShowMyservice.vue?vue&type=template&id=63a60f64"
import script from "./ShowMyservice.vue?vue&type=script&lang=js"
export * from "./ShowMyservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports